
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class OrderGrid extends _Ext.GridBase<OrderRow, any> {
        protected getColumnsKey() { return 'Purchase.Order'; }
        protected getDialogType() { return OrderDialog; }
        protected getIdProperty() { return OrderRow.idProperty; }
        protected getInsertPermission() { return OrderRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderRow.localTextPrefix; }
        protected getService() { return OrderService.baseUrl; }
        //private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            var item = this.itemAt(row);
            super.onClick(e, row, cell);
        }
        protected addButtonClick() {

            let now = new Date();

            var voucherNo = FormatHelper.GetVoucherNo(53);
            this.editItem(<OrderRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                VoucherTypeId: 53,
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                UserId: Q.Authorization.userDefinition.UserId,
                CurrencyId: Q.Authorization.userDefinition.CurrencyId,
                TransDate: now.toDateString()
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}